<template>
  <section
    :class="[hasTransition ? 'transition' : '', isMobile ? 'mobile' : '']"
    :style="`top: ${position.y}px; left: ${position.x}px; width: ${dimensions.x}px; height: ${dimensions.y}px;`"
  >
    <CLINav v-if="!isMobile" />

    <template v-if="!isMinimized">
      <Suspense v-if="!isMobile && !isLoading">
        <CLIInput />
      </Suspense>

      <div :class="['cli-container', isMobile ? 'mobile' : '']">
        <router-view />
      </div>

      <CLIPaletteMobile v-if="isMobile" />
      <CloseDialog v-if="isCloseDialog" />
    </template>
  </section>
</template>

<script lang="ts">
import { defineComponent, Ref, ref, watch } from 'vue'
import CLINav from '@/components/cliControls/CLINav.vue'
import CLIInput from '@/components/cliControls/CLIInput.vue'
import CLIPaletteMobile from '@/components/cliControls/CLIPaletteMobile.vue'
import CloseDialog from '@/components/cliControls/CloseDialog.vue'
import cliUiStore from '@/store/cliUi'
import breakpointsStore from '@/store//breakpoints'

export default defineComponent({
  name: 'CLI',
  components: {
    CLINav,
    CLIInput,
    CLIPaletteMobile,
    CloseDialog
  },

  mounted() {
    cliUiStore.initializeWindowRestrictions()
    cliUiStore.initializeDefaultPosition()
  },

  setup() {
    const hasTransition: Ref<boolean> = ref(false)

    watch(cliUiStore.isMinimized, (): void => {
      if (cliUiStore.isMinimized.value) {
        hasTransition.value = true
      } else {
        setTimeout(() => {
          hasTransition.value = false
        }, 200)
      }
    })

    return {
      window,
      hasTransition,
      isMinimized: cliUiStore.isMinimized,
      isCloseDialog: cliUiStore.isCloseDialog,
      isLoading: cliUiStore.isLoading,
      isMobile: breakpointsStore.isMobile,
      breakpoint: breakpointsStore.breakpoint,
      position: cliUiStore.position,
      dimensions: cliUiStore.dimensions
    }
  }
})
</script>

<style scoped>
section {
  position: absolute;
  border: 4px solid var(--building-color);
  background-color: var(--background-color);
  font-size: 1.3rem;
}
section.transition {
  transition: all 0.2s;
}
section.mobile {
  border: none;
}
.cli-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - var(--cli-header-height) - var(--cli-input-height) - 2rem);
  overflow: auto;
  padding: 1rem;
}
.cli-container.mobile {
  height: calc(100% - 2rem);
  padding-top: 0rem;
  padding-bottom: 0rem;
}
</style>
